import { Column, Row } from '@xing-com/xing-grid';

import type { SalutationProps } from './salutation';
import { Salutation } from './salutation';

type SmallScreenSalutationRowProps = SalutationProps & {
  className?: string;
};

export function SmallScreenSalutationRow({
  className = '',
  heading,
  premiumContacts,
  showFacepile,
}: SmallScreenSalutationRowProps): JSX.Element {
  return (
    <Row className={className}>
      <Column size={7} sizeWide={0}>
        <Salutation
          heading={heading}
          premiumContacts={premiumContacts}
          showFacepile={showFacepile}
        />
      </Column>
    </Row>
  );
}
